import CryptoJS from "react-native-crypto-js";

// 'servizi' parte vuoto e viene riempito dai dati del DB (/config del backend)
export const servizi = {};

// chiamata all'avvio da index.js, prima del render
export async function loadConfig() {
    try {
        const res = await fetch(`${process.env.REACT_APP_APIADDRESS}/config`);
        if(!res.ok) throw new Error('HTTP ' + res.status);
        let data = await res.json();

        // backend nuovo: { config: "<criptato>" } - backend vecchio: oggetto in chiaro (ramo da togliere quando il backend nuovo è in produzione)
        if (typeof data?.config === 'string') {
            const bytes = CryptoJS.AES.decrypt(data.config, process.env.REACT_APP_CHIAVE_CRIPTAZIONE);
            data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        }
        if (!data || Object.keys(data).length === 0) throw new Error('config vuoto');

        Object.keys(servizi).forEach(k => delete servizi[k]);   // svuota in place
        Object.assign(servizi, data);                           // riempi coi dati del DB
    } catch (e) {
        console.warn('[config] config non caricato:', e.message);
    }
}